import { styled } from "@mui/material";

export const CardTitle = styled("div")({
    display: "flex",
    alignItems: "center",
    padding: "12px 16px",
});
